// extracted by mini-css-extract-plugin
module.exports = {"Modal":"bbx_a bgu_bk bgu_bl bgu_bm bgu_bo bgu_bn bgu_vh","Modal__backdrop":"bbx_b bbx_a bgu_bk bgu_bl bgu_bm bgu_bo bgu_bn bgu_vh bgu_cz"};